import { Controller } from "stimulus";
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from "swiper/modules";
import "swiper/swiper-bundle.min.css";

function toggleOpacity(element) {
  if (element.classList.contains('opacity-100')) {
    element.classList.remove('opacity-100');
    element.classList.add('opacity-0');
    setTimeout(function () {
      element.classList.add('hidden');
    }, 600);

  } else {
    element.classList.remove('hidden');
    setTimeout(function () {
      element.classList.remove('opacity-0');
      element.classList.add('opacity-100');
    }, 1);
  }
}

export default class extends Controller {
  static targets = ["galleryWrapper", "slidesWrapper"];

  connect() {
    //Disable Swiper warnings
    this.restoreWarn = console.warn;
    console.warn = function () { };
    Swiper.use([Navigation, Pagination, Scrollbar, A11y]);
  };

  disconnect() {
    //Restore Swiper warnings
    console.warn = this.restoreWarn;
  }

  close(event) {
    //this.galleryWrapperTarget.classList.add("hidden");

    toggleOpacity(this.galleryWrapperTarget);
    document.getElementsByTagName("body")[0].classList.remove("overflow-hidden");
    if (this.swiper) {
      this.swiper.destroy(false, false);
    }
    setTimeout(function () {
      document.getElementById('back-to-top-a').classList.remove('hidden');
    }, 200);
  };
  open(event) {
    document.getElementById('back-to-top-a').classList.add('hidden');
    let set = event.params.set || 'all';
    let slideTo = event.params.index || 0;
    if (this.hasSlidesWrapperTarget && this.element.dataset.galleryImageSets) {
      this.renderSlides(set);
    }
    document.getElementsByTagName("body")[0].classList.add("overflow-hidden");

    this.swiper = new Swiper(this.galleryWrapperTarget, {
      direction: 'horizontal',
      loop: true,
      pagination: {
        el: this.galleryWrapperTarget.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.galleryWrapperTarget.querySelector('.swiper-button-next'),
        prevEl: this.galleryWrapperTarget.querySelector('.swiper-button-prev'),
      },
      scrollbar: {
        el: this.galleryWrapperTarget.querySelector('.swiper-scrollbar'),
      },
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      preventClicks: false,
      preventClicksPropagation: false,
      centeredSlides: true,
    });

    //this.galleryWrapperTarget.classList.remove("hidden");
    toggleOpacity(this.galleryWrapperTarget);
    this.swiper.slideTo(slideTo);
    this.swiper.attachEvents()
    this.swiper.updateSlides();
    this.swiper.updateSlidesClasses();
  };

  renderSlides(set) {
    let imageSets = JSON.parse(this.element.dataset.galleryImageSets || '{}');
    let images = imageSets[set] || imageSets.all || [];

    this.slidesWrapperTarget.innerHTML = images.map((image) => `
      <figure class="swiper-slide flex flex-col flex-wrap items-center justify-center">
        <img src="${this.escapeAttribute(image.url)}" alt="${this.escapeAttribute(image.alt || '')}" class="object-scale-down h-4/5 px-4 md:px-10 xl:px-0" />
        <figcaption class="text-mongreenmid text-center mt-2">${this.escapeHtml(image.copyright || '')}</figcaption>
      </figure>
    `).join('');
  }

  escapeAttribute(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  escapeHtml(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
}
